
(function () {
  var classAdded = false;
  var $normalHeader = $('.kuchenstil-menu.navbar');


  $(window).scroll(function () {
    if ($(document).scrollTop() > $normalHeader.outerHeight() && !classAdded) {
      $normalHeader.addClass('navbar-small');
      classAdded = true;
    } else if ($(document).scrollTop() < $normalHeader.outerHeight() && classAdded) {
      $normalHeader.removeClass('navbar-small');
      classAdded = false;
    }
  });
  $('body > .layout-container').prepend("<div class=\"active-menu-overlay position-fixed bg-black w-100 h-100 \"></div>");

})();
// adjust header height if admin toolbar is visible
jQuery(document).ready(function($) {
  if ($('#toolbar-administration').length) {
    $('.kuchenstil-menu.navbar .menu-inner').css('margin-top', '5rem');
  }
});

$(document).ready(function() {
  var $toggler = $('.navbar-toggler');
  var $menu = $('#navbarSupportedContent');

  $toggler.on('click', function(event) {
    event.preventDefault(); // Prevent the default Bootstrap behavior
    event.stopPropagation(); // Stop the event from bubbling up

    var isOpen = $menu.hasClass('show');

    if (isOpen) {
      $menu.removeClass('show');
      $toggler.removeClass('open');
    } else {
      $menu.addClass('show');
      $toggler.addClass('open');
    }
  });
});

$(document).ready(function() {
  function handleMobileDropdownClick() {
    $('.navbar-nav .dropdown-toggle').off('click').on('click', function(e) {
      var $el = $(this);
      var $subMenu = $el.next(".dropdown-menu");
      var isOpen = $subMenu.hasClass('show');

      if (!isOpen) {
        e.preventDefault(); // Prevent the default action on the first click
        $('.navbar-nav .show').removeClass('show'); // Close any open dropdowns
        $subMenu.addClass('show'); // Open the clicked dropdown
        $el.parent("li").addClass('show');
      } else {
        window.location.href = $el.attr('href'); // Redirect to the parent item's URL on the second click
      }
    });

    $('.navbar-nav .nav-link:not(.dropdown-toggle)').off('click').on('click', function() {
      var url = $(this).attr('href');
      window.location.href = url; // Redirect to the URL on the first click
    });
  }

  function handleDesktopDropdownClick() {
    $('.navbar-nav .dropdown-toggle').off('click').on('click', function(e) {
      var url = $(this).attr('href');
      window.location.href = url; // Redirect to the URL on click
    });
  }

  function initDropdown() {
    if ($(window).width() < 992) {
      handleMobileDropdownClick();
    } else {
      handleDesktopDropdownClick();
    }
  }

  $(window).resize(function() {
    initDropdown();
  });

  initDropdown();
});


